const GET_STUDENT_ASSIGNMENTS = `query GetStudentAssignments($classId: ID!, $filter: TeacherInboxQueryFilter) {
    teacherClassInbox(classId: $classId, filter: $filter) {
      assignments {
        assignmentId
        assignmentType
        assignmentCategory
        assignor
        lessonPlanId
        clpId
        createdAt
        curriculumInfo {
          curriculumPlanId
          curriculumId
          curriculumSkills {
            order
            skillId
            unitName
            lessonName
          }
        }
        dateFrom
        dateTo
        entityId
        entityType
        parentId
        status
        manifest {
          activityType
          sequence
          locale
          storyId
          status
          skills {
            lessonName
            order
            skillId
            unitName
          }
        }
        resources
      }
      studentAssignments {
        assignmentIds
        entityId
        entityType
      }
    }
  }`;
  
  export default GET_STUDENT_ASSIGNMENTS;
  